import events from 'events.js';
import ko from 'knockout';
import 'ko/bindings/stop_binding.js';

class Page {
    // Let pages display alert messages
    constructor() {
        this.messageQueue = ko.observableArray([]);
        this.message = ko.observable();
        this.messageType = ko.observable();
        this.processing = ko.observable(false);
        this.defaultTimeout = 3000;
        this.messageGap = 300;
        this.alertTypes = {
            ERROR: 'danger',
            INFO: 'info',
            SUCCESS: 'success',
            WARNING: 'warning',
        };

        this.messageClass = ko.pureComputed(() => {
            if (this.messageType()) {
                return `alert top alert-${this.messageType()}`;
            } else {
                return 'hide';
            }
        });

        this.processMessage = this.processMessage.bind(this);
    }

    alert(type, message, timeout) {
        timeout = timeout || this.defaultTimeout;
        this.messageQueue.push({
            message,
            type,
            timeout,
        });

        if (!this.processing()) {
            this.processing(true);
            this.processMessage();
        }
    }

    processMessage() {
        const next = this.messageQueue.shift();
        const div = document.getElementById('alert');
        if (next) {
            this.message(next.message);
            this.messageType(next.type);
            if (div) {
                div.classList.remove('hide');
                setTimeout(
                    () => div.classList.add('hide'),
                    next.timeout - this.messageGap,
                );
            }
            setTimeout(this.processMessage, next.timeout);
        } else {
            this.processing(false);
            this.message(null);
            this.messageType(null);
        }
    }

    async load() {
        await events.ready();

        const div = document.getElementById('alert');
        if (div) {
            ko.applyBindings(this, div);
        }
    }
}

export const page = new Page();
page.load();
